// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"07ab1b03","74":"8f6651ef","466":"263112a5","527":"263112a5","689":"a5b987a9"}[chunkId] + ".chunk.css";
};